// extracted by mini-css-extract-plugin
export default {"badge":"badge---lwNZe","label":"label---paN70","default":"default---mLOcI","red":"red---gZOEh","primary":"primary---sdAjB","small":"small---JUWJ4","medium":"medium---Ft1bH"};